import { isAfter, isBefore } from 'date-fns'

import CONSTANTS from '@/constants'

const { LIVE_VIRTUAL_TRAININGS } = CONSTANTS

export const liveVirtualTrainingsHydratation = LVTCollection => {
  LVTCollection?.forEach(liveVirtualTraining => {
    liveVirtualTraining.product_type = 'live_virtual_training'
    switch (liveVirtualTraining.merchant_id) {
      case LIVE_VIRTUAL_TRAININGS.CCIE_SECURITY_V6:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          startDate: 'September 11',
          endDate: 'September 15',
          year: '2023',
          schedule: '11am - 1pm ET',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CHATGPT_AND_IA:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Tim Warner',
          startDate: 'March 20',
          endDate: 'March 22',
          year: '2024',
          schedule: '1pm - 3pm ET',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_ACI:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'October 21',
          endDate: 'October 23',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCNA:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Keith Bogart',
          startDate: 'October 14',
          endDate: 'October 18',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_AWS:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Alexis Ahmed',
          startDate: 'May 13',
          endDate: 'May 15',
          year: '2024',
          schedule: '1pm - 5pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_V6_1:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'December 09',
          endDate: 'December 13',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CISSP:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Frank Satterwhite',
          startDate: 'January 27',
          endDate: 'January 31',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_SECURITY_PLUS:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian Oliff',
          startDate: 'October 28',
          endDate: 'November 1',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_20250407:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'October 6',
          endDate: 'October 10',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          descriptionAppend: ``,
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCNP_ENCOR_20250526:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Keith Bogart',
          startDate: 'October 27',
          endDate: 'November 25',
          year: '2025',
          schedule: '10am - 4pm ET (Extended Event)',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CISCO_ACI_20250324:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'December 16',
          endDate: 'December 18',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_SECURITY_20250421:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          startDate: 'October 20',
          endDate: 'October 24',
          year: '2025',
          schedule: '9am - 5pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_ADV_NET_AUTOMATION_20250331:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          startDate: 'December 8',
          endDate: 'December 12',
          year: '2025',
          schedule: '9am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_AZ_900_20250317:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Tracy Wallace',
          startDate: 'August 25',
          endDate: 'August 28',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          descriptionAppend: ``,
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_AZ_104_20250421:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Tracy Wallace',
          startDate: 'December 8',
          endDate: 'December 12',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CYBER_ASSOCIATE_20250609:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Keith Bogart & Brian Oliff',
          startDate: 'December 8',
          endDate: 'December 12',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CISSP_20250724:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Frank Satterwhite',
          startDate: 'October 13',
          endDate: 'October 17',
          year: '2025',
          schedule: '11am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_AWS_SAA:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Tracy Wallace',
          startDate: 'December 15',
          endDate: 'December 19',
          year: '2025',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      default:
        break
    }
  })
  LVTCollection?.sort((lvtA, lvtB) => {
    const startDateA = `${lvtA.startDate}, ${lvtA.year}`
    const startDateB = `${lvtB.startDate}, ${lvtB.year}`
    if (isBefore(new Date(startDateA), new Date(startDateB))) {
      return -1
    }
    if (isAfter(new Date(startDateA), new Date(startDateB))) {
      return 1
    }
    return 0
  })
  if (Array.isArray(LVTCollection) && LVTCollection.length > 0) {
    LVTCollection[0].upNext = true
  }
}
